import {
  checkAUSite,
  checkNZSite,
  getStoreCountryCode,
} from '../../modules/sms-validation'

export const COUNTRY_ISO_CODE = getStoreCountryCode()
export const IS_NZ_STORE = checkNZSite()
export const IS_AU_STORE = checkAUSite()
export const MINIMUM_ABN_NUMBERS = 10
export const MINIMUM_NZBN_NUMBERS = 13
export const MINIMUM_QUERY_LENGTH = 3

export const PRIVATE_BUSINESS_NAME_LABEL = `Business name kept private`
export const BUSINESS_LOOKUP_SELECTORS = {
  AU: {
    businessNumberHiddenInputSelector: `[name="abn"]`,
    legalNameInputSelector: `[name="legal_name"]`,
    privateLegalNameInputSelector: `[name="private_legal_name"]`,
    confirmedBusinessDetailsContainerSelector: `#confirmed-business-details`,
  },
  NZ: {
    businessNumberHiddenInputSelector: `[name="nzbn"]`,
    legalNameInputSelector: `[name="legal_name"]`,
    privateLegalNameInputSelector: `[name="private_legal_name"]`,
    confirmedBusinessDetailsContainerSelector: `#confirmed-business-details`,
  },
}

const BASE_API_ENDPOINT = (window.location.host.includes(`staging`) || window.location.host.includes(`test`)) ?
    `https://staging.silverchef.finance` :
    `https://www.silverchef.finance`

export const AU_LOOKUP_API_ENDPOINT =
  `${BASE_API_ENDPOINT}`
export const NZ_LOOKUP_API_ENDPOINT =
    `${BASE_API_ENDPOINT}`

const setMinimumBusinessNumbers = () =>
  IS_AU_STORE ? MINIMUM_ABN_NUMBERS : MINIMUM_NZBN_NUMBERS

const setApiEndpoint = () =>
  IS_AU_STORE
    ? `${AU_LOOKUP_API_ENDPOINT}`
    : `${NZ_LOOKUP_API_ENDPOINT}`

export const MINIMUM_INPUT_LENGTH = setMinimumBusinessNumbers()
export const LOOKUP_API_ENDPOINT = setApiEndpoint()
